import { datePipe } from "shared/pipes";

const LOG_ACTIONS = {
  ADDED_TO_BOX: "Added to box",
  RETURNED: "Returned",
  IN_STORAGE: "In storage",
  MISSING: "Went missing",
  KEPT: "Single item subscription",
  ARCHIVED: "Archived"
};

class LogAction {
  constructor(logAction) {
    this.time = logAction.time;
    this.action = logAction.action;
    this.location = logAction.location;
  }

  get date() {
    return datePipe.transform(this.time);
  }
}

export default class Log {
  constructor(log) {
    this.boxID = log.boxID;

    this.actions = [];

    if (log.addedToBox) {
      this.actions.push(
        new LogAction({
          time: log.addedToBox,
          action: LOG_ACTIONS.ADDED_TO_BOX,
          location: log.userEmail,
        })
      );
    }

    if (log.processedReturn) {
      this.actions.push(
        new LogAction({
          time: log.processedReturn,
          action: LOG_ACTIONS.RETURNED,
          location: "Washing",
        })
      );
    }

    if (log.toStorage) {
      this.actions.push(
        new LogAction({
          time: log.toStorage,
          action: LOG_ACTIONS.IN_STORAGE,
          location: "Storage",
        })
      );
    }
    if (log.declared_missing) {
      this.actions.push(
        new LogAction({
          time: log.declared_missing,
          action: LOG_ACTIONS.MISSING,
          location: "At customer",
        })
      );
    }
    if (log.declared_kept) {
      this.actions.push(
        new LogAction({
          time: log.declared_kept,
          action: LOG_ACTIONS.KEPT,
          location: "At Customer",
        })
      );
    }

    this.actions.sort((a, b) => {
      if (a.time > b.time) {
        return -1;
      }
      if (a.time < b.time) {
        return 1;
      }

      return 0;
    });

    this.userEmail = log.userEmail;
    this.userID = log.userID;
  }

  formatForCSVDownload() {
    const overrideValues = {
      addedToBox: this.actions[0] ? this.actions[0].date : null,
      processedReturn: this.actions[1] ? this.actions[1].date : null,
      toStorage: this.actions[2] ? this.actions[2].date : null,
    };

    return { ...this.toJSON(), ...overrideValues };
  }

  toJSON() {
    return {
      boxID: this.boxID,
      addedToBox: this.actions[0] ? this.actions[0].time : null,
      processedReturn: this.actions[1] ? this.actions[1].time : null,
      toStorage: this.actions[2] ? this.actions[2].time : null,
      userEmail: this.userEmail,
      userID: this.userID,
    };
  }
}
